import React from 'react';
import { Box, Container, Grid, Typography, Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowSmallBlue from '../../assets/ArrowSmall_Blue.svg';
import { useAppContext } from '../AppContext';

export const Page9: React.FC = () => {
    const { openModal } = useAppContext();
    const benefits = [
        { title: 'Exclusive Pricing', description: 'Enjoy special discounts on all our premium products.' },
        { title: 'Community Membership', description: 'Be a part of a vibrant and supportive community of wellness enthusiasts.' },
        { title: 'Event Access', description: 'Gain entry to the latest wellness-related events, workshops, and seminars.' },
        { title: 'Product Launches', description: 'Receive early access and in-depth exclusivity when new products are launched.' },
        { title: 'Sales Incentives', description: 'Receive attractive rewards when customers buy products through your referrals.' },
        { title: 'Personal Growth', description: 'Benefit from continuous learning opportunities and personal development resources.' },
        { title: 'Support System', description: 'Enjoy dedicated support and resources to help you succeed in your BA journey.' },
    ];

    return (
        <Box sx={{ backgroundColor: '#fff' }}>
            <Container maxWidth={false} sx={{ paddingTop: '40px', paddingBottom: '40px', borderBottomRightRadius: '36px', borderBottomLeftRadius: '36px' }}>
                <Grid container spacing={2} alignItems="stretch" justifyContent="center">
                    {/* Left Side */}
                    <Grid item xs={12} md={8} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Card
                            sx={{
                                borderRadius: '20px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                flexGrow: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}
                        >
                            <CardContent>
                                <Typography
                                    variant="h2"
                                    sx={{
                                        fontFamily: 'ClaireMurphy',
                                        fontSize: { xs: '28px', sm: '36px', md: '42px' },
                                        fontWeight: 400,
                                        lineHeight: '50px',
                                        textAlign: 'left',
                                        color: 'rgba(61, 61, 61, 1)',
                                        marginBottom: '16px',
                                    }}
                                >
                                    JOIN THE LAVISHA FAMILY
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand',
                                        fontSize: '18px',
                                        fontWeight: 500,
                                        lineHeight: '28px',
                                        letterSpacing: '-0.02em',
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginBottom: '16px',
                                    }}
                                >
                                    Become a part of the Lavisha family and unlock exclusive benefits!
                                </Typography>
                                <List>
                                    {benefits.map((benefit, index) => (
                                        <ListItem key={index} sx={{ paddingTop: '2px', paddingBottom: '2px' }}>
                                            <ListItemIcon>
                                                <CheckCircleIcon sx={{ color: '#003087', fontSize: '24px' }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Box>
                                                        <Typography
                                                            component="span"
                                                            sx={{
                                                                fontFamily: 'Quicksand',
                                                                fontSize: '16px',
                                                                fontWeight: 700,
                                                                lineHeight: '24px',
                                                                textAlign: 'left',
                                                                color: 'rgba(61, 61, 61, 1)',
                                                            }}
                                                        >
                                                            {benefit.title}
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand',
                                                                fontSize: '14px',
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                textAlign: 'left',
                                                                color: 'rgba(61, 61, 61, 1)',
                                                            }}
                                                        >
                                                            {benefit.description}
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                            <Box
                                onClick={() => openModal()}
                                component={'a'}
                                sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '12px', position: 'relative', cursor: 'pointer' }}>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        color: '#003087',
                                        marginRight: '8px',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    JOIN NOW
                                </Typography>

                                <Box
                                    component="img"
                                    src={ArrowSmallBlue}
                                    alt="Arrow"
                                    sx={{
                                        width: '40px',
                                        height: '40px',
                                    }}
                                />
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        bottom: '5px',
                                        left: 0,
                                        right: 0,
                                        height: '1px',
                                        backgroundColor: '#003087',
                                        borderRadius: '0 0 16px 16px',
                                    }}
                                />
                            </Box>

                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};
